var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCorner2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14931_12034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.77778 3.55469H0V5.33247H1.77778V3.55469Z",
    fill: "#777575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.77778 0H0V1.77778H1.77778V0Z",
    fill: "#777575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.77778 14.2227H0V16.0004H1.77778V14.2227Z",
    fill: "#777575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.77778 7.11133H0V8.88911H1.77778V7.11133Z",
    fill: "#777575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33332 14.2227H3.55554V16.0004H5.33332V14.2227Z",
    fill: "#777575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.77778 10.666H0V12.4438H1.77778V10.666Z",
    fill: "#777575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 10.666H14.2222V12.4438H15.9999V10.666Z",
    fill: "#777575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5555 0H7.11108V1.77778H11.5555C13.0266 1.77778 14.2222 2.97334 14.2222 4.44444V8.88888H16V4.44444C16 1.99556 14.0044 0 11.5555 0Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33332 0H3.55554V1.77778H5.33332V0Z",
    fill: "#777575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 14.2227H14.2222V16.0004H15.9999V14.2227Z",
    fill: "#777575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.88887 14.2227H7.11108V16.0004H8.88887V14.2227Z",
    fill: "#777575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4444 14.2227H10.6666V16.0004H12.4444V14.2227Z",
    fill: "#777575"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14931_12034"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorner2);
export default __webpack_public_path__ + "static/media/corner 2.3f12d77401a501164b4db379efc89157.svg";
export { ForwardRef as ReactComponent };